import { TypeaheadSearchBar } from 'venn-components';
import React, { useCallback } from 'react';
import { useRecentLibrarySearches } from './logic/useRecentLibrarySearches';
import { userActivity } from 'venn-utils';

const RECENT_SEARCH_MAX_ITEMS = 5;
interface LibraryTypeaheadSearchBarProps {
  searchText: string | undefined;
  onSearchTextChange: (arg0: string) => void;
  placeholder: string;
}
export const LibraryTypeaheadSearchBar = ({
  searchText = '',
  placeholder,
  onSearchTextChange,
}: LibraryTypeaheadSearchBarProps) => {
  const { recentSearches, saveRecentSearch } = useRecentLibrarySearches(
    RECENT_SEARCH_MAX_ITEMS,
    userActivity.USER_LIBRARY_RECENT_QUERIES,
  );
  const handleSearchSelect = useCallback(
    (val: string) => {
      onSearchTextChange(val);
      saveRecentSearch(val);
    },
    [onSearchTextChange, saveRecentSearch],
  );
  const onBlur = useCallback(() => saveRecentSearch(searchText), [saveRecentSearch, searchText]);
  return (
    <TypeaheadSearchBar
      placeholder={placeholder}
      value={searchText}
      onChange={onSearchTextChange}
      onSelect={handleSearchSelect}
      onBlur={onBlur}
      debounce={500}
      dropdownOptions={recentSearches}
      dropdownOptionsHeader="Recent Searches"
      disableAutofocus
    />
  );
};
